module.exports = __webpack_public_path__ + "img/hr-inserter-hand-open.2cab5ff0.png";